import styled from 'styled-components';
import { COLORS } from '../../shared/colours';

const BorderRadiusContainer = styled.div`
  background-color: ${COLORS.surface};
  height: 100%;
`;

export default BorderRadiusContainer;
